// Tabs funciotns
function openTab(event, blockData) {
  var i, tabcontent, tablinks;
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  event.currentTarget.className += " active";
  updateCarouselContent(JSON.parse(blockData));
}

function extractData(key, data) {
  let dictionary = {};
  let counter = 1;
  while(data.hasOwnProperty(`${key}_${counter}`)) {
    dictionary[counter] = data[`${key}_${counter}`];
    counter++;
  }
  return dictionary;
}


// Dynamic carousel
function updateCarouselContent(blockData = null) {
  const carousel = document.getElementById("dynamic_carousel");
  const imagesDict = extractData("image", blockData);
  const subtitleDict = extractData("subtitle", blockData);
  const linkDict = extractData("link_url", blockData);
  const length = Object.keys(imagesDict).length;

  // Clear existing carousel content
  carousel.innerHTML = "";

  // Populate carousel with new content
  for (let i = 1; i <= length; i++) {
    const li = document.createElement("li");
    li.className = "card";
    li.innerHTML = `
        <a href="${linkDict[i]}" class="carousel-link">
          <div class="carousel-images">
            <img 
              src= ${imagesDict[i]}
              alt="alt_${subtitleDict[i]}"
              loading="lazy"
            >
          </div>
        </a>
    `;
    carousel.appendChild(li);
  }

  // Control visibility of navigation buttons based on the number of items
  const leftButton = document.getElementById('left');
  const rightButton = document.getElementById('right');
  if (length <= 3) {
    leftButton.style.display = 'none';
    rightButton.style.display = 'none';
  } else {
    leftButton.style.display = '';
    rightButton.style.display = '';
  }
}
